<template>
  <BaseDialog :dialog="dialog"
        :max_width="`800`"
        @close_dialog="closeQRSearch">
        <template v-slot:title>
            Ricerca per QRCode
        </template>
        
        <div class="d-flex flex-column align-baseline full-width">
            <v-container>
            <v-row no-gutters>
                <v-col cols="12 pb-2">
                    <qrcode-stream :camera="camera" @init="onQRReaderInit" @decode="onQRDecode">
                        <div class="loading-indicator" v-if="qr_loading">
                            Loading...
                        </div>
                    </qrcode-stream>
                </v-col>
                <v-col cols="6">
                    <v-text-field dense outlined
                        label="QRCode"
                        v-model="code"
                    ></v-text-field>
                </v-col>
                <v-col cols="6" class="d-flex justify-end">
                    <v-btn @click.stop="searchQRMatch">cerca</v-btn>
                    
                </v-col>
                <v-col cols="12">
                    <div v-if="ids!=null">
                        <div v-if="ids.length>0">
                            <div v-for="item in ids" :key="item.id" >
                                <InstrumentItem 
                                      :instrument_id="item.id"
                                      :can_change="false">
                                  </InstrumentItem>
                            </div>
                        </div>
                        <v-btn v-else @click.stop="goToInstrument(null)">crea nuovo</v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-center">
                    <v-btn @click.stop="closeQRSearch">chiudi</v-btn>    
                </v-col>
            </v-row>
            </v-container>
        </div>       
    </BaseDialog>
</template>

<script>

import BaseDialog from './BaseDialog'
import { searchDesign } from "../../utils/dbUtility"
import InstrumentItem from "../../views/instruments/InstrumentItem"
// data: {dialog: false, message: "", choices: [{key, val, mod}]}
export default  {
    components: { BaseDialog, InstrumentItem },
    props: {
        "dialog": {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data(){
      return {
          code: '',
          ids: null,
          camera: 'auto',
          qr_loading: false,
        }
    },
    watch: {
        dialog() {
            this.camera = this.dialog ? 'auto' : 'off'
        }
    },
    methods: {
        closeQRSearch() {
            this.code = ''
            this.ids = null
            this.camera = 'off'
            this.$emit("close")
        },
        getSmartId(data) {
            let smart_id = decodeURIComponent(data)
            
            let match = this.$store.state.config.qrcode.prefixes.reduce((cur, p) => { 
                let a = data.startsWith(p) && p.length>cur.length ? p : cur
                return a
            }, "")
            return smart_id.substring(match.length)
        },
        async onQRDecode(code) {
            this.code = null
            this.ids = null
            let smart_id = this.getSmartId(code)
            console.log("CODE", code, smart_id)
            this.code = smart_id
            await this.searchQRMatch()    
        },
        async searchQRMatch() {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'key', ["qr_code", this.code], false)
            console.log("collision", res)
            if (res!=undefined && res!=null && res.length>0) {
                this.ids = res
                console.log('instruments', res)
            } else  {
                this.ids = []
                //this.showQRReader = false
            }
        },
        goToInstrument(i_id) {
            this.code = ''
            this.instr_id = ''
            this.$emit('show_detail', i_id)
        },
        async onQRReaderInit(promise) {
            try {
                this.qr_loading = true;
                await promise
            } catch (error) {
                if (error.name === 'NotAllowedError') {
                this.error = "ERROR: you need to grant camera access permission"
                } else if (error.name === 'NotFoundError') {
                this.error = "ERROR: no camera on this device"
                } else if (error.name === 'NotSupportedError') {
                this.error = "ERROR: secure context required (HTTPS, localhost)"
                } else if (error.name === 'NotReadableError') {
                this.error = "ERROR: is the camera already in use?"
                } else if (error.name === 'OverconstrainedError') {
                this.error = "ERROR: installed cameras are not suitable"
                } else if (error.name === 'StreamApiNotSupportedError') {
                this.error = "ERROR: Stream API is not supported in this browser"
                } else if (error.name === 'InsecureContextError') {
                this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
                } else {
                this.error = `ERROR: Camera error (${error.name})`;
                }
            } finally {
                this.qr_loading = false;
            }
        },
    }
}

</script>
